if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.countrySelect = this.querySelector('select[name="country_code"]');
        this.langSelect = this.querySelector('select[name="locale_code"]');
        this.form = this.querySelector('form');
      }

      changeLanguages(e) {
        if (!this.langSelect) return;
        const availableLanguages = this.querySelectorAll(`.spare-languages option[data-available-for="${e.target.value}"]`);

        if (availableLanguages.length === 0) {
          console.warn('No languages available for the selected country');
          return;
        }

        this.langSelect.innerHTML = '';
        availableLanguages.forEach((opt, index) => {
          const clone = opt.cloneNode(true);
          if(index === 0) clone.selected = true;
          this.langSelect.appendChild(clone);
        });
      }

      handleSubmit(e) {
        e.preventDefault();
        const selectedOption = this.langSelect.options[this.langSelect.selectedIndex];
        selectedOption.dataset && selectedOption.dataset.url ? window.location = selectedOption.dataset.url : this.form.submit();
      }

      sortOptions() {
        const sectionSelects = this.querySelectorAll('select');
        sectionSelects.forEach((select) => {
          const selectedOption = select.querySelector('option[selected]');
          const options = Array.from(select.options);
          options.sort((a, b) => a.text.localeCompare(b.text));
          select.innerHTML = '';
          let selected = false
          options.forEach((opt) => {
            select.appendChild(opt)
            if (selected == false && opt.value === selectedOption.value) {
              selected = true;
              opt.selected = true;
            }
          });
        });
      }

      connectedCallback() {
        if(this.countrySelect) this.countrySelect.addEventListener('change', (e) => this.changeLanguages(e));
        if(this.form) this.form.addEventListener('submit', (e) => this.handleSubmit(e))
        this.sortOptions();
      }
    }
  );
}
